module.exports = __webpack_public_path__ + "img/002.a4254e62.gif";